import React, { useState } from 'react'

const Counter = ({ max, step, setQuantita, positive }) => {
  const [count, setCount] = useState(0)
  const handleIncrement = () => {
    setCount(count + 1)
    setQuantita(count)
  }
  const handleDecrement = () => {
    if (positive && count === 0) {
      return
    }
    setCount(count - 1)
    setQuantita(count)
  }

  return (
    <div className="counter-main-container">
      <div className="controls">
        <button onClick={handleIncrement}>+</button>
        <p className="count">{count}</p>
        <button onClick={handleDecrement}>-</button>
      </div>
    </div>
  )
}

export default Counter
